import React from "react";
import { useTranslation } from "react-i18next";

import {
  WeekDaysContainer,
  WeekdayBox,
} from "../../custom_modules/ShiftSchedule/CreateShift/createShiftStyles";
import { useWeekConfig } from "../../utils/weekConfig";

const WeekdaySelector = ({ activeDays, onDaySelect, className, style }) => {
  const { t } = useTranslation();
  const { weekStart } = useWeekConfig();

  // Create dynamic weekdays array based on user's week start preference
  const getOrderedWeekdays = () => {
    const allDays = [
      { key: "sunday", label: t("sun") },
      { key: "monday", label: t("mon") },
      { key: "tuesday", label: t("tue") },
      { key: "wednesday", label: t("wed") },
      { key: "thursday", label: t("thu") },
      { key: "friday", label: t("fri") },
      { key: "saturday", label: t("sat") },
    ];

    // Find the start index based on weekStart
    const startIndex = allDays.findIndex(day => day.key === weekStart);

    // Reorder the array to start with the configured week start day
    return [...allDays.slice(startIndex), ...allDays.slice(0, startIndex)];
  };

  const orderedWeekdays = getOrderedWeekdays();

  return (
    <WeekDaysContainer className={className} style={style}>
      {orderedWeekdays.map(day => (
        <WeekdayBox
          key={day.key}
          active={activeDays[day.key]}
          onClick={() => onDaySelect(day.key)}
        >
          {day.label}
        </WeekdayBox>
      ))}
    </WeekDaysContainer>
  );
};

export default WeekdaySelector;
